module.exports = __webpack_public_path__ + "static/media/SELAN.6a4be935.png";